/**
 * Tag Party
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PartyTagState = {
  partyTag: {
    showDialog: false,
  },
}

export const PartyTagActions = {
  tagParty: async ({ commit }, req) => {
    return axiosRequest.
      post(`/parties/${req.id}/tags`, {
        tag_ids: req.tagIds,
      }).
      then(({ data }) => {
        commit('pePatchParty', { tags: data.tags })
      }).
      catch(handleError)
  },

  untagParty: async ({ commit }, req) => {
    return axiosRequest.
      delete(`/parties/${req.id}/tags/${req.tagId}`).
      then(({ data }) => {
        commit('pePatchParty', { tags: data.tags })
      }).
      catch(handleError)
  },
}

export const PartyTagMutations = {
  setShowTagPartyDialog: (state, payload) => {
    state.partyTag.showDialog = payload
  },
}

export const PartyTagGetters = {
  showDialogPartyTag: state => state.partyTag.showDialog,
}
